type Props = {
  text?: string;
};

export default function AmountType({ text }: Props) {
  return (
    <abbr
      className="text-left text-sm font-normal no-underline opacity-70"
      data-testid="checkout-amount-type"
      style={{
        border: "none",
        cursor: "inherit",
        fontVariant: "small-caps",
        lineHeight: "inherit",
      }}
      title="U.S. Dollar"
    >
      {text ?? ""}
    </abbr>
  );
}
